module.exports = __webpack_public_path__ + "img/hishamuddin_eyes.ab746250.jpg";